import { useContext } from "react";
import { AppContext } from "../App";
import { carePillars, hospitalInfo } from "../content/hospitalContent";
import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import { FiShield, FiUsers, FiWind, FiPlus, FiGlobe, FiCpu, FiBarChart2, FiCheck, FiTarget, FiEye, FiLayers } from "react-icons/fi"; 
import banner1 from "../assets/banner2.jpg";
import banner2 from "../assets/banner1.jpg";
import { IoMdArrowForward } from "react-icons/io";
import Footer from "./Footer";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);

  const getIcon = (title) => {
    const t = title.toLowerCase();
    if (t.includes("safety")) return <FiShield />;
    if (t.includes("team")) return <FiUsers />;
    if (t.includes("calm") || t.includes("comfort")) return <FiWind />;
    return <FiPlus />;
  };

  return (
    <>
      <style>{`
        :root {
          --clinical-teal: #0d9488;
          --deep-navy: #0f172a;
          --soft-slate: #64748b;
          --bg-clean: #ffffff;
          --slate-50: #f8fafc;
          --slate-100: #f1f5f9;
          --slate-200: #e2e8f0;
          --font-main: 'Inter', system-ui, -apple-system, sans-serif;
        }

        .care-section {
          font-family: var(--font-main);
          background-color: var(--bg-clean);
          padding: 75px 0;
          color: var(--deep-navy);
          position: relative;
        }

        .care-section::before {
          content: '+';
          position: absolute;
          font-size: 20rem;
          font-weight: 900;
          color: #f1f5f9;
          top: -50px;
          right: -50px;
          line-height: 1;
          pointer-events: none;
          z-index: 0;
        }

        .care-container {
          max-width: 1300px;
          margin: 0 auto;
          padding: 0 40px;
          position: relative;
          z-index: 1;
        }

        .care-header { margin-bottom: 80px; }

        .care-label {
          display: flex;
          align-items: center;
          gap: 12px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.2em;
          font-size: 0.75rem;
          color: var(--clinical-teal);
          margin-bottom: 24px;
        }

        .care-label::after {
          content: "";
          height: 1px;
          width: 60px;
          background: var(--clinical-teal);
        }

        .care-title {
          font-size: clamp(2.8rem, 6vw, 4.5rem);
          font-weight: 800;
          line-height: 1;
          letter-spacing: -0.05em;
          margin: 0;
        }

        .care-title span { color: var(--soft-slate); font-weight: 300; }

        .care-grid {
          display: grid;
          grid-template-columns: repeat(12, 1fr);
          gap: 60px;
          align-items: flex-start;
        }

        .care-pillars-list {
          grid-column: 1 / 6;
          display: flex;
          flex-direction: column;
          gap: 48px;
        }

        .pillar-item { position: relative; padding-left: 56px; }

        .pillar-icon-wrapper {
          position: absolute;
          left: 0;
          top: 0;
          width: 40px;
          height: 40px;
          background: var(--deep-navy);
          color: white;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.2rem;
          box-shadow: 0 10px 20px rgba(15, 23, 42, 0.1);
        }

        .pillar-title {
          font-size: 1.1rem;
          font-weight: 700;
          margin: 0 0 8px 0;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .pillar-desc { color: var(--soft-slate); line-height: 1.6; margin: 0; font-size: 0.95rem; }

        .care-visuals { grid-column: 7 / 13; position: relative; padding-top: 40px; }

        .img-frame { position: relative; overflow: hidden; border-radius: 8px; }

        .img-frame::after {
          content: "";
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, var(--deep-navy), transparent);
          opacity: 0.4;
        }

        .img-main { width: 90%; height: 500px; object-fit: cover; display: block; }

        .img-sub-frame {
          position: absolute;
          bottom: -40px;
          right: 0;
          width: 60%;
          height: 300px;
          border: 15px solid var(--bg-clean);
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 30px 60px rgba(0,0,0,0.15);
        }

        .img-sub { width: 100%; height: 100%; object-fit: cover; }

        .btn-modern {
          padding: 18px 36px;
          background: var(--deep-navy);
          color: white;
          font-weight: 700;
          text-transform: uppercase;
          font-size: 0.8rem;
          letter-spacing: 0.1em;
          border: none;
          cursor: pointer;
          transition: 0.4s cubic-bezier(0.16, 1, 0.3, 1);
          display: inline-flex;
          align-items: center; gap: 12px;
        }

        .btn-modern:hover { background: var(--clinical-teal); padding-right: 48px; }

        .strat-section {
          background: var(--slate-50);
          padding: 50px 0;
          font-family: var(--font-main);
        }

        .strat-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
          margin-top: 60px;
        }

        .strat-grid-4 {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 30px;
          margin-top: 60px;
        }

        .strat-card {
          background: #ffffff;
          padding: 40px;
          border-radius: 12px;
          border: 1px solid var(--slate-200);
          transition: all 0.4s ease;
          display: flex;
          flex-direction: column;
        }

        .strat-card:hover { transform: translateY(-10px); box-shadow: 0 20px 40px rgba(0,0,0,0.05); border-color: var(--clinical-teal); }

        .horizon-tag {
          font-size: 0.7rem;
          font-weight: 800;
          color: var(--clinical-teal);
          text-transform: uppercase;
          letter-spacing: 0.1em;
          margin-bottom: 12px;
          display: block;
        }

        .strat-icon-box {
          font-size: 2rem;
          color: var(--deep-navy);
          margin-bottom: 20px;
        }

        .price-card {
          background: #ffffff;
          padding: 35px 30px;
          border-radius: 12px;
          border: 1px solid var(--slate-200);
          text-align: center;
          transition: all 0.4s ease;
        }

        .price-card:hover {
          transform: translateY(-5px);
          border-color: var(--clinical-teal);
          box-shadow: 0 15px 30px rgba(13, 148, 136, 0.08);
        }

        .price-val { font-size: 1.8rem; font-weight: 800; color: var(--deep-navy); margin: 5px 0; }
        .price-sub { font-size: 0.75rem; color: var(--soft-slate); margin: 0 0 20px 0; font-weight: 500; }
        .price-feat { font-size: 0.85rem; color: var(--soft-slate); list-style: none; padding: 0; margin: 20px 0; text-align: left; }
        .price-feat li { margin-bottom: 12px; display: flex; align-items: flex-start; gap: 10px; line-height: 1.4; }

        @media (max-width: 1024px) {
          .care-grid, .strat-grid, .strat-grid-4 { grid-template-columns: 1fr; }
          .care-pillars-list, .care-visuals { grid-column: 1 / -1; }
          .img-main { width: 100%; height: 350px; }
          .img-sub-frame { width: 50%; height: 200px; }
        }
      `}</style>

      <section className="strat-section">
        <div className="care-container">
          <header className="care-header" style={{ textAlign: "center", marginBottom: "40px" }}>
            <h2 className="care-title" style={{ fontSize: "3rem" }}>Guided by <span>Purpose.</span></h2>
            <p style={{ color: "var(--soft-slate)", marginTop: "20px", maxWidth: "700px", margin: "20px auto" }}>
              Nanguba Healthcare is built on a technology-enabled network designed to transform 
              health outcomes and set new clinical benchmarks across Tanzania.
            </p>
          </header>

          <div className="strat-grid-4">
            {/* Purpose */}
            <div className="strat-card">
              <div className="strat-icon-box"><FiLayers /></div>
              <span className="horizon-tag">Institutional Purpose</span>
              <h3 style={{ fontSize: "1.25rem", marginBottom: "15px" }}>Building Institutions</h3>
              <p style={{ fontSize: "0.9rem", color: "var(--soft-slate)", lineHeight: "1.6" }}>
                Accessible Care. Patient-Centered. We are not merely opening facilities; we are building an institution to transform healthcare for generations.
              </p>
            </div>
            
            {/* Mission */}
            <div className="strat-card" >
              <div className="strat-icon-box" style={{ color: "var(--clinical-teal)" }}><FiTarget /></div>
              <span className="horizon-tag">The Mission</span>
              <h3 style={{ fontSize: "1.25rem", marginBottom: "15px" }}>Integrated Excellence</h3>
              <p style={{ fontSize: "0.9rem", color: "var(--soft-slate)", lineHeight: "1.6" }}>
                To deliver accessible, high-quality healthcare across clinics and hospitals—using integrated systems and ethical practice to improve outcomes for all.
              </p>
            </div>

            {/* Vision */}
            <div className="strat-card">
              <div className="strat-icon-box"><FiEye /></div>
              <span className="horizon-tag">The Vision</span>
              <h3 style={{ fontSize: "1.25rem", marginBottom: "15px" }}>The African Benchmark</h3>
              <p style={{ fontSize: "0.9rem", color: "var(--soft-slate)", lineHeight: "1.6" }}>
                To become a leading technology-driven network in Tanzania—recognized for clinical excellence and setting the benchmark for community healthcare in Africa.
              </p>
            </div>

            {/* Core Values */}
            <div className="strat-card">
              <div className="strat-icon-box"><FiCheck /></div>
              <span className="horizon-tag">Core Values</span>
              <h3 style={{ fontSize: "1.25rem", marginBottom: "15px" }}>Our Principles</h3>
              <ul style={{ fontSize: "0.9rem", color: "var(--soft-slate)", lineHeight: "1.6", paddingLeft: "20px", margin: 0 }}>
                <li>Accessibility</li>
                <li>Integrity</li>
                <li>Patient-Centered</li>
                <li>Community Impact</li>
                <li>Excellence</li>
                <li>Innovation</li>
                <li>Sustainability</li>
                <li>Accountability</li>
              </ul>
            </div>
          </div>

        </div>
      </section>
      <Footer/>
    </>
  );
}